(function() {
  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.from((root || document).querySelectorAll(sel)); }

  function create(tag, attrs) {
    const el = document.createElement(tag);
    if (attrs) {
      if (attrs.dataset) {
        const ds = attrs.dataset;
        delete attrs.dataset;
        Object.keys(ds).forEach((k) => {
          try { el.dataset[k] = ds[k]; } catch (_) { el.setAttribute('data-' + k, ds[k]); }
        });
      }
      Object.assign(el, attrs);
    }
    return el;
  }

  function StoryPlayer(container) {
    this.container = container;
    this.modalSelector = container.dataset.modalSelector || null;
    this.modal = this.modalSelector ? document.querySelector(this.modalSelector) : (qs(container, '.stories-modal') || document.querySelector('.stories-modal'));
    this.progressBars = [];
    this.items = [];
    this.currentIndex = 0;
    this.isPaused = false;
    this.isMuted = true;
    this.loop = container.dataset.loop === 'true';
    this.autoClose = container.dataset.autoClose === 'true';
    // elements inside modal – will be resolved in init() relative to modal
    this.mediaWrap = null;
    this.titleEl = null;
    this.avatarEl = null;
    this.playBtn = null;
    this.muteBtn = null;
    this.prevBtn = null;
    this.nextBtn = null;
    this.closeBtn = null;
    this.navZones = [];
    this.timer = null;
    this.player = null; // iframe api or video element
    this.duration = 0;
    this.lastRaf = 0;
    this.boundOnKey = this.onKey.bind(this);
    this.boundUpdate = this.updateProgress.bind(this);
    // touch swipe handlers (mobile only)
    this._touch = { x: 0, y: 0, t: 0, active: false };
    this.boundTouchStart = this.onTouchStart.bind(this);
    this.boundTouchMove = this.onTouchMove.bind(this);
    this.boundTouchEnd = this.onTouchEnd.bind(this);

    this.init();
  }

  function getPauseSVG() {
    return '<svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.60449 18.3375L9.60449 7.66309" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.6963 18.3375L16.6963 7.66309" stroke="#FFFFFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  }

  function getPlaySVG() {
    return '<svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.547 12.4326C19.8163 12.6325 19.8163 13.0357 19.547 13.2356L10.9304 19.6318C10.6004 19.8767 10.1323 19.6412 10.1323 19.2303L10.1323 6.43788C10.1323 6.027 10.6004 5.7915 10.9304 6.03641L19.547 12.4326Z" fill="#FFFFFF"></path></svg>';
  }

  function getMutedSVG() {
    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9921 5.4303C14.5779 5.4303 14.2421 5.76608 14.2421 6.1803C14.2421 6.59451 14.5779 6.9303 14.9921 6.9303V5.4303ZM14.9921 6.9303C19.6072 6.9303 21.7286 12.3311 19.1167 15.3564L20.2521 16.3367C23.6848 12.3607 20.9192 5.4303 14.9921 5.4303V6.9303Z" fill="#FFFFFF"></path><path d="M8.35677 7.78748L6.79845 9.39007H4.50523C3.67294 9.39007 3.00003 10.063 3.00003 10.8953V13.9499C3.00003 14.7734 3.66409 15.4374 4.47867 15.4551L6.78074 15.4906L11.1193 19.8291C11.2002 19.9067 11.302 19.959 11.4122 19.9796C11.5225 20.0002 11.6363 19.9881 11.7398 19.9448C11.8432 19.9015 11.9318 19.829 11.9946 19.7361C12.0574 19.6431 12.0917 19.5339 12.0932 19.4218V11.3645" fill="#FFFFFF"></path><path d="M11.4122 3.98583C11.302 4.00639 11.2002 4.0587 11.1193 4.13635L9.71725 5.823L12.0932 8.20076V4.54364C12.0917 4.43151 12.0574 4.32228 11.9946 4.22936C11.9318 4.13645 11.8432 4.0639 11.7398 4.02063C11.6363 3.97737 11.5225 3.96527 11.4122 3.98583Z" fill="#FFFFFF"></path><path d="M5.70944 4.80359L20.9385 20.0238" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.75 18.5099C16.557 18.3138 17.318 17.9619 17.9901 17.474" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round"></path><path d="M15.6243 9.13196C15.2101 9.13196 14.8743 9.46774 14.8743 9.88196C14.8743 10.2962 15.2101 10.632 15.6243 10.632V9.13196ZM15.6243 10.632C15.6793 10.632 15.7976 10.6598 15.968 10.835C16.1364 11.0083 16.2994 11.2725 16.4211 11.5853C16.5423 11.8969 16.6047 12.2111 16.6076 12.4603C16.6108 12.7388 16.5418 12.7992 16.569 12.7709L17.6472 13.8138C18.0275 13.4206 18.1125 12.8721 18.1075 12.4428C18.1022 11.9842 17.994 11.4913 17.8191 11.0415C17.6446 10.593 17.3858 10.1415 17.0434 9.78937C16.703 9.43921 16.2214 9.13196 15.6243 9.13196V10.632Z" fill="#FFFFFF"></path></svg>';
  }

  function getVolumeSVG() {
    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.9921 6.22363C17.4697 6.22363 21 7.94976 21 12.2293C21 17.0022 16.4693 18.6891 14.9921 18.6891" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.6243 9.47412C16.2021 9.71658 17.4254 10.4558 17.4254 12.1628C17.4254 14.1423 16.2021 14.8333 15.6243 15.1566" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.47864 15.4464C3.66406 15.4287 3 14.7646 3 13.9412V10.8865C3 10.0631 3.66406 9.39901 4.47864 9.38131L6.78072 9.34589L11.1192 4.17965C11.2002 4.102 11.302 4.04969 11.4122 4.02913C11.5225 4.00857 11.6363 4.02067 11.7398 4.06393C11.8432 4.1072 11.9318 4.17975 11.9946 4.27266C12.0574 4.36558 12.0917 4.47481 12.0932 4.58694V19.4131C12.0917 19.5252 12.0574 19.6344 11.9946 19.7274C11.9318 19.8203 11.8432 19.8928 11.7398 19.9361C11.6363 19.9793 11.5225 19.9914 11.4122 19.9709C11.302 19.9503 11.2002 19.898 11.1192 19.8204L6.78072 15.4818L4.47864 15.4464Z" fill="#FFFFFF"></path></svg>';
  }

  StoryPlayer.prototype.init = function() {
    // console.log removed for production stability

    // collect items from buttons
    this.items = qsa(this.container, '.story-card').map(function(btn){
      return {
        title: btn.getAttribute('data-title') || '',
        type: btn.getAttribute('data-type'),
        src: btn.getAttribute('data-src'),
        start: parseInt(btn.getAttribute('data-start') || '0', 10) || 0,
        poster: btn.getAttribute('data-poster') || ''
      };
    });
    // media/items count useful only when debugging globally

    // ensure we have a reference to modal internals (it may have been moved to body by web component)
    if (!this.modal && this.modalSelector) this.modal = document.querySelector(this.modalSelector);
    this.mediaWrap = this.modal ? qs(this.modal, '.stories-media') : null;
    this.titleEl = this.modal ? qs(this.modal, '.stories-title') : null;
    this.avatarEl = this.modal ? qs(this.modal, '.stories-avatar') : null;
    this.playBtn = this.modal ? qs(this.modal, '[data-action="toggle-play"]') : null;
    this.muteBtn = this.modal ? qs(this.modal, '[data-action="toggle-mute"]') : null;
    this.prevBtn = this.modal ? qs(this.modal, '[data-action="prev"]') : null;
    this.nextBtn = this.modal ? qs(this.modal, '[data-action="next"]') : null;
    this.closeBtn = this.modal ? (qs(this.modal, '[data-action="close"]') || qs(this.modal, '.product-popup-modal__toggle')) : null;
    this.navZones = this.modal ? qsa(this.modal, '.stories-nav__zone') : [];
    // keep quiet in normal mode

    // build progress bars
    var progressHost = this.modal ? qs(this.modal, '.stories-progress') : null;
    if (!progressHost) {
      console.error('[stories] progress host introuvable');
      return; // stop init to avoid errors
    }
    progressHost.innerHTML = '';
    this.progressBars = this.items.map(function(_, i){
      var bar = create('div', { className: 'stories-progress__bar', dataset: { index: i } });
      var fill = create('span');
      bar.appendChild(fill);
      bar.addEventListener('click', this.seekTo.bind(this, i));
      progressHost.appendChild(bar);
      return fill;
    }.bind(this));

    // wire list buttons
    qsa(this.container, '.story-card').forEach(function(btn, i){
      btn.addEventListener('click', function(){ this.open(i, btn); }.bind(this));
    }.bind(this));

    // controls
    if (this.playBtn) this.playBtn.addEventListener('click', this.togglePlay.bind(this));
    if (this.muteBtn) this.muteBtn.addEventListener('click', this.toggleMute.bind(this));
    if (this.prevBtn) this.prevBtn.addEventListener('click', this.prev.bind(this));
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.next.bind(this));
    if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));

    // nav zones (tap areas)
    if (this.navZones[0]) this.navZones[0].addEventListener('click', this.prev.bind(this));
    if (this.navZones[1]) this.navZones[1].addEventListener('click', this.next.bind(this));

    // modal debug hooks
    // set initial mute icon
    this.renderMuteState();
    // this.attachModalDebug();
  };

  StoryPlayer.prototype.attachModalDebug = function() {
    if (!this.modal) {
      console.warn('[stories] attachModalDebug: modal introuvable au init');
      return;
    }
    try {
      var obs = new MutationObserver(function(muts){
        muts.forEach(function(m){
          if (m.attributeName === 'open') {
            console.log('[stories] modal attribute open=', this.modal.hasAttribute('open'));
          }
        }.bind(this));
      }.bind(this));
      obs.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
    } catch (e) { console.warn('[stories] MutationObserver failed', e); }

    document.body.addEventListener('modalClosed', function(){
      console.log('[stories] body event modalClosed');
    });
  };

  StoryPlayer.prototype.open = function(index, trigger) {
    this.triggerEl = trigger || null;
    this.currentIndex = index;
    // log media only
    if (!this.modal && this.modalSelector) {
      this.modal = document.querySelector(this.modalSelector);
      console.log('[stories] requery modal by selector', this.modalSelector, '=>', this.modal);
    }
    // no spam in console
    try {
      if (this.modal && this.modal.parentNode !== document.body) {
        
        document.body.appendChild(this.modal);
      }
      if (this.modal && typeof this.modal.show === 'function') {
        
        this.modal.show(trigger);
      } else if (this.modal) {
        
        this.modal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      } else {
        console.error('[stories] Modal introuvable. Vérifie data-modal-selector et l’ID du modal.');
        return;
      }
      // filets de sécurité
      setTimeout(function(){
        if (!this.modal.hasAttribute('open')) {
          
          this.modal.setAttribute('open', '');
          document.body.classList.add('overflow-hidden');
        }
      }.bind(this), 0);
    } catch (e) {
      console.error('[stories] erreur ouverture modal', e);
      if (this.modal) {
        this.modal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      }
    }
    document.addEventListener('keydown', this.boundOnKey);
    // animation in
    var frame = qs(this.modal, '.stories-frame');
    if (frame) {
      frame.classList.add('stories-anim-in');
      requestAnimationFrame(function(){ frame.classList.add('is-active'); });
    }

    this.mountMedia(this.items[index]);
    // fermer en cliquant hors du player
    var self = this;
    this._outsideClick = function(ev){
      var frame = qs(self.modal, '.stories-frame');
      if (frame && !frame.contains(ev.target)) {
        self.close();
      }
    };
    document.addEventListener('click', this._outsideClick, true);
    this.updateHeader();
    this.isPaused = false;
    this.renderPlayState();
    this.loopRaf();

    // Attach swipe only on mobile
    this.attachSwipeHandlers();

    // Attach click-to-pause on media area
    this.attachMediaTapPause();
  };

  StoryPlayer.prototype.close = function() {
    cancelAnimationFrame(this.lastRaf);
    document.removeEventListener('keydown', this.boundOnKey);
    // animation out
    var frame = qs(this.modal, '.stories-frame');
    if (frame) {
      frame.classList.remove('stories-anim-in','is-active');
      frame.classList.add('stories-anim-out');
      // attendre la fin de transition (~320ms)
      var self = this;
      setTimeout(function(){ self.unmountMedia(); }, 320);
    } else {
      this.unmountMedia();
    }
    if (this.modal && typeof this.modal.hide === 'function') {
      console.log('[stories] calling modal.hide');
      this.modal.hide();
    } else if (this.modal) {
      console.log('[stories] removing attribute open');
      this.modal.removeAttribute('open');
    }
    if (this._outsideClick) {
      document.removeEventListener('click', this._outsideClick, true);
      this._outsideClick = null;
    }
    this.detachSwipeHandlers();
    this.detachMediaTapPause();
    this.detachFrameTapToClose();
    if (this.triggerEl) this.triggerEl.focus();
  };

  StoryPlayer.prototype.onKey = function(e) {
    if (e.key === 'Escape') return this.close();
    if (e.key === 'ArrowRight') return this.next();
    if (e.key === 'ArrowLeft') return this.prev();
    if (e.key === ' ') { e.preventDefault(); return this.togglePlay(); }
    if (e.key.toLowerCase() === 'm') return this.toggleMute();
  };

  StoryPlayer.prototype.updateHeader = function() {
    var item = this.items[this.currentIndex];
    this.titleEl.textContent = item.title || '';
    if (this.avatarEl && item.poster) {
      this.avatarEl.setAttribute('src', item.poster);
    }
    this.progressBars.forEach(function(fill, i){ fill.style.width = i < this.currentIndex ? '100%' : '0%'; }.bind(this));
  };

  StoryPlayer.prototype.seekTo = function(index, forceAutoplay) {
    this.currentIndex = index;
    this.updateHeader();
    
    // Force autoplay lors des swipes/navigation mobile
    var shouldAutoplay = forceAutoplay || this.isMobile();
    if (shouldAutoplay) {
      this.isPaused = false;
      this.renderPlayState();
    }
    
    this.mountMedia(this.items[index], shouldAutoplay);
    
    // Démarrer la boucle de progression si en autoplay
    if (shouldAutoplay) {
      this.loopRaf();
    }
  };

  StoryPlayer.prototype.next = function(forceAutoplay) {
    if (this.currentIndex < this.items.length - 1) {
      this.seekTo(this.currentIndex + 1, !!forceAutoplay);
    } else if (this.loop) {
      this.seekTo(0, !!forceAutoplay);
    } else if (this.autoClose) {
      this.close();
    } else {
      this.seekTo(0, !!forceAutoplay);
    }
  };

  StoryPlayer.prototype.prev = function(forceAutoplay) {
    if (this.currentIndex > 0) this.seekTo(this.currentIndex - 1, !!forceAutoplay);
  };

  StoryPlayer.prototype.togglePlay = function() {
    this.isPaused = !this.isPaused;
    var media = this.player;
    if (!media) return;
    if (media.tagName === 'VIDEO') {
      if (this.isPaused) media.pause(); else media.play();
    } else if (media.contentWindow) {
      // best-effort postMessage API for YT/Vimeo
      var cmd = this.isPaused ? 'pauseVideo' : 'playVideo';
      media.contentWindow.postMessage(JSON.stringify({ event: 'command', func: cmd }), '*');
    }
    this.renderPlayState();
    if (!this.isPaused) {
      // redémarrer la boucle de progression après une pause
      this.loopRaf();
    }
  };

  StoryPlayer.prototype.renderPlayState = function() {
    this.playBtn.setAttribute('aria-pressed', (!this.isPaused).toString());
    // swap icon: show pause when playing, play when paused
    if (this.isPaused) {
      this.playBtn.setAttribute('aria-label', 'Play');
      this.playBtn.innerHTML = getPlaySVG();
    } else {
      this.playBtn.setAttribute('aria-label', 'Pause');
      this.playBtn.innerHTML = getPauseSVG();
    }
  };

  StoryPlayer.prototype.toggleMute = function() {
    this.isMuted = !this.isMuted;
    var media = this.player;
    if (!media) return;
    if (media.tagName === 'VIDEO') {
      media.muted = this.isMuted;
    } else if (media.contentWindow) {
      var cmd = this.isMuted ? 'mute' : 'unMute';
      media.contentWindow.postMessage(JSON.stringify({ event: 'command', func: cmd }), '*');
    }
    this.renderMuteState();
  };

  StoryPlayer.prototype.renderMuteState = function() {
    if (!this.muteBtn) return;
    if (this.isMuted) {
      this.muteBtn.setAttribute('aria-label', 'Unmute');
      this.muteBtn.innerHTML = getMutedSVG();
    } else {
      this.muteBtn.setAttribute('aria-label', 'Mute');
      this.muteBtn.innerHTML = getVolumeSVG();
    }
  };

  StoryPlayer.prototype.unmountMedia = function() {
    this.mediaWrap.innerHTML = '';
    this.player = null;
    this.duration = 0;
  };

  StoryPlayer.prototype.mountMedia = function(item, forceAutoplay) {
    console.log('[stories] mount media', item, 'autoplay:', forceAutoplay);
    this.unmountMedia();
    var el;
    if (item.type === 'mp4') {
      el = create('video');
      // sécu: forcer https si l'URL est protocole-less
      var src = item.src || '';
      if (src.startsWith('//')) src = 'https:' + src;
      el.src = src;
      el.playsInline = true;
      el.autoplay = forceAutoplay !== false; // Par défaut true, sauf si explicitement false
      el.muted = this.isMuted;
      el.controls = false;
      el.addEventListener('loadedmetadata', function(){
        try { if (item.start) el.currentTime = item.start; } catch(_){}
        this.duration = el.duration || 0;
        console.log('[stories] video loadedmetadata duration=', this.duration);
      }.bind(this));
      el.addEventListener('playing', function(){ console.log('[stories] video playing'); }.bind(this));
      el.addEventListener('pause', function(){ console.log('[stories] video pause'); }.bind(this));
      el.addEventListener('error', function(e){ console.error('[stories] video error', e, el.error); }.bind(this));
      el.addEventListener('ended', function(){ console.log('[stories] video ended'); this.next(); }.bind(this));
      this.mediaWrap.appendChild(el);
    } else if (item.type === 'youtube' || item.type === 'vimeo') {
      var src = item.src;
      if (item.type === 'youtube' && src.indexOf('embed') === -1) {
        // transform watch url to embed
        var id = src.split('v=')[1] || src.split('/').pop();
        id = (id || '').split('&')[0];
        src = 'https://www.youtube.com/embed/' + id;
      }
      var params = ['playsinline=1','rel=0'];
      if (forceAutoplay !== false) params.push('autoplay=1'); // Autoplay selon le paramètre
      if (this.isMuted) params.push('mute=1');
      if (item.start) params.push('start=' + item.start);
      var finalSrc = src + (src.indexOf('?')>-1?'&':'?') + params.join('&');
      console.log('[stories] iframe src', finalSrc);
      el = create('iframe', { allow: 'autoplay; fullscreen', src: finalSrc });
      el.setAttribute('frameborder', '0');
      el.addEventListener('load', function(){ console.log('[stories] iframe loaded'); });
      this.mediaWrap.appendChild(el);
      // no precise duration without APIs; use fallback 15s segments if unknown
      this.duration = 0;
      // try listen for end using YouTube API postMessage ready → not guaranteed; fallback timer
      setTimeout(function(){ console.log('[stories] iframe fallback next'); if (!this.isPaused) this.next(); }.bind(this), 15000);
    }
    this.player = el;
  };

  StoryPlayer.prototype.loopRaf = function() {
    cancelAnimationFrame(this.lastRaf);
    this.lastRaf = requestAnimationFrame(this.boundUpdate);
  };

  StoryPlayer.prototype.updateProgress = function(ts) {
    var fill = this.progressBars[this.currentIndex];
    if (fill) {
      var ratio = 0;
      if (this.player && this.player.tagName === 'VIDEO' && this.player.duration) {
        this.duration = this.player.duration;
        ratio = (this.player.currentTime || 0) / (this.duration || 1);
      }
      fill.style.width = Math.max(0, Math.min(100, ratio * 100)) + '%';
    }
    if (!this.isPaused) this.loopRaf();
  };

  // --- Mobile swipe navigation ---
  StoryPlayer.prototype.isMobile = function() {
    return typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  };

  StoryPlayer.prototype.attachSwipeHandlers = function() {
    if (!this.isMobile()) return;
    if (!this.modal) return;
    var frame = qs(this.modal, '.stories-frame');
    if (!frame) return;
    frame.addEventListener('touchstart', this.boundTouchStart, { passive: true });
    frame.addEventListener('touchmove', this.boundTouchMove, { passive: true });
    frame.addEventListener('touchend', this.boundTouchEnd, { passive: true });
  };

  StoryPlayer.prototype.detachSwipeHandlers = function() {
    if (!this.modal) return;
    var frame = qs(this.modal, '.stories-frame');
    if (!frame) return;
    frame.removeEventListener('touchstart', this.boundTouchStart);
    frame.removeEventListener('touchmove', this.boundTouchMove);
    frame.removeEventListener('touchend', this.boundTouchEnd);
  };

  StoryPlayer.prototype.onTouchStart = function(e) {
    if (!e.touches || !e.touches.length) return;
    var t = e.touches[0];
    this._touch.x = t.clientX;
    this._touch.y = t.clientY;
    this._touch.t = Date.now();
    this._touch.active = true;
  };

  StoryPlayer.prototype.onTouchMove = function(e) {
    // nothing: passive tracking only
  };

  StoryPlayer.prototype.onTouchEnd = function(e) {
    if (!this._touch.active) return;
    this._touch.active = false;
    var dt = Date.now() - this._touch.t;
    var touch = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : null;
    if (!touch) return;
    var dx = touch.clientX - this._touch.x;
    var dy = touch.clientY - this._touch.y;
    var absX = Math.abs(dx);
    var absY = Math.abs(dy);
    // Thresholds: horizontal swipe, quick-ish gesture
    if (absX > 40 && absX > absY && dt < 800) {
      // ignore if tapped on a control button
      var target = e.target;
      if (target && (target.closest('.stories-btn') || target.closest('[data-action]'))) return;
      if (dx < 0) {
        // swipe left → next with autoplay
        this.next(true);
      } else {
        // swipe right → prev with autoplay
        this.prev(true);
      }
    }
    // Vertical swipe down to close (Instagram-like)
    else if (absY > 50 && absY > absX && dt < 800) {
      var target2 = e.target;
      if (target2 && (target2.closest('.stories-btn') || target2.closest('[data-action]'))) return;
      if (dy > 0) {
        // swipe down → close
        this.close();
      }
    }
  };

  // --- Tap to pause/play on media ---
  StoryPlayer.prototype.attachMediaTapPause = function() {
    if (!this.modal) return;
    var mediaArea = this.mediaWrap || qs(this.modal, '.stories-media');
    if (!mediaArea) return;
    var self = this;
    this._mediaTapPause = function(ev){
      // Ignore taps on controls
      if (ev.target.closest('.stories-btn') || ev.target.closest('[data-action]')) return;
      // Click toggles play state; if playing => pause
      if (!self.isPaused) {
        self.togglePlay();
      } else {
        // keep simple tap to resume as well for UX
        self.togglePlay();
      }
    };
    mediaArea.addEventListener('click', this._mediaTapPause);
  };

  StoryPlayer.prototype.detachMediaTapPause = function() {
    if (!this.modal || !this._mediaTapPause) return;
    var mediaArea = this.mediaWrap || qs(this.modal, '.stories-media');
    if (!mediaArea) return;
    mediaArea.removeEventListener('click', this._mediaTapPause);
    this._mediaTapPause = null;
  };

  // --- Mobile: tap on empty area closes ---
  StoryPlayer.prototype.attachFrameTapToClose = function() {
    if (!this.isMobile() || !this.modal) return;
    var frame = qs(this.modal, '.stories-frame');
    var player = qs(this.modal, '.stories-player');
    if (!frame) return;
    var self = this;
    this._frameTapClose = function(ev){
      var t = ev.target;
      if (t.closest('.stories-btn') || t.closest('[data-action]')) return;
      if (player && !player.contains(t)) {
        self.close();
      }
    };
    frame.addEventListener('click', this._frameTapClose);
  };

  StoryPlayer.prototype.detachFrameTapToClose = function() {
    if (!this.modal || !this._frameTapClose) return;
    var frame = qs(this.modal, '.stories-frame');
    if (!frame) return;
    frame.removeEventListener('click', this._frameTapClose);
    this._frameTapClose = null;
  };

  // bootstrap all story blocks on page
  document.addEventListener('DOMContentLoaded', function() {
    var roots = qsa(document, '.stories[data-player]');
    roots.forEach(function(root){ try { new StoryPlayer(root); } catch (e) { console.error('[stories] init error', e); } });
  });
})();

